<template>
  <div class="card">
    <div class="bg-blue-light px-1 rounded pb-2">
      <TitleButton
          class="mt-1"
          btnTitle="List"
          :showBtn="true"
          :showAddNew="false"
          :title="headerTitle"
          @onClickCloseButton="navigateToListPage"
      />
    </div>
    <div class="px-2 mt-1">
      <div class="card card-height">
        <div class="row mt-2 gy-1">
          <div class="row mt-1">
            <div class="col-12 col-sm-6 col-md-4 col-lg-4 mb-1">
              <label class="form-label">Employee <span class="required">*</span></label>
              <AsyncSelect
                  placeholder="Select Employee"
                  v-model="contactProfile"
                  :api-service="fetchContactProfiles"
                  :additional-query="additionalContactOption"
              />
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4  mb-1">
              <label class="form-label">Loan Amount <span class="required">*</span></label>
              <input
                  class="form-control invoice-edit-input  "
                  tabindex="1"
                  type="number"
                  step="any"
                  placeholder="Loan Amount...."
                  v-model="formData.loan_amount"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4  mb-1">
              <label class="form-label">Number Of Installment <span class="required">*</span></label>
              <input
                  class="form-control invoice-edit-input  "
                  tabindex="1"
                  type="number"
                  placeholder="Number Of Installment."
                  v-model="formData.number_of_installment"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4  mb-1">
              <label class="align-middle">Installment Interval <span class="required">*</span></label>
              <v-select
                  placeholder="Select Interval"
                  v-model="formData.installment_interval"
                  :options="installmentInterval"
                  :reduce="name => name.value"
                  label="name"
              />
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4  mb-1">
              <label class="align-middle">Interest Method <span class="required">*</span></label>
              <v-select
                  placeholder="Select Method"
                  v-model="formData.interest_method"
                  :options="interestMethod"
                  :reduce="name => name.value"
                  label="name"
              />
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4  mb-1">
              <label class="form-label">Interest Percentage</label>
              <input
                  class="form-control invoice-edit-input  "
                  tabindex="1"
                  type="number"
                  placeholder="Interest Percentage."
                  step="any"
                  v-model="formData.interest_percentage"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4  mb-1">
              <label class="form-label">Total Interest Amount</label>
              <input
                  class="form-control invoice-edit-input  "
                  tabindex="1"
                  type="text"
                  readonly
                  placeholder="Total Interest Amount."
                  v-model="formData.total_interest_amount"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4  mb-1">
              <label class="form-label">Installment Principle Amount</label>
              <input
                  class="form-control invoice-edit-input  "
                  tabindex="1"
                  type="text"
                  readonly
                  placeholder="Installment Principle Amount"
                  v-model="formData.installment_principal_amount"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4  mb-1">
              <label class="form-label">Installment Interest Amount</label>
              <input
                  class="form-control invoice-edit-input  "
                  tabindex="1"
                  type="text"
                  readonly
                  placeholder="Installment Interest Amount"
                  v-model="formData.installment_interest_amount"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4  mb-1">
              <label class="form-label">Installment Amount</label>
              <input
                  class="form-control invoice-edit-input  "
                  tabindex="1"
                  type="text"
                  readonly
                  placeholder="Total Installment Amount."
                  v-model="formData.installment_amount"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Installment Start Date</label>
              <input
                  class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                  tabindex="1"
                  type="date"
                  placeholder=""
                  v-model="formData.installment_start_date"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Installment End Date</label>
              <input
                  class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                  tabindex="1"
                  type="date"
                  placeholder=""
                  v-model="formData.installment_end_date"
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-2 d-flex justify-content-start justify-content-sm-center px-2 gap-1 flex-wrap pb-2">
      <hr class="hr-full-width mb-1">
      <button :disabled="saveButtonLoader || saveNewButtonLoader" @click="saveAP()"
              class="btn btn-primary">
        Save
      </button>
      <button :disabled="saveButtonLoader || saveNewButtonLoader" @click="saveAP(false)"
              class="btn btn-primary">Save & New
      </button>
      <button @click="navigateToListPage" class="btn btn-outline-secondary">Cancel</button>
    </div>

    <GlobalLoader/>
  </div>
</template>
<script setup>
import {computed, inject, onMounted, ref, watch} from 'vue'
import {useRoute, useRouter} from "vue-router";
import TitleButton from '@/components/atom/TitleButton'
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import GlobalLoader from "@/components/atom/GlobalLoader.vue";
import {useStore} from "vuex";
import handleContact from "@/services/modules/contact";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";

const store = useStore();
const router = useRouter()
const route = useRoute()
const showError = inject('showError');
const showSuccess = inject('showSuccess')
const companyId = computed(() => {
  return route.params.companyId
})

let loader =ref(false)
let saveButtonLoader = ref(false)
let saveNewButtonLoader = ref(false)
let isCreate = ref(true)
let contactProfile = ref(null)
let headerTitle = ref("Add Loan Register")
let loanRegisterEditData = ref({})
const additionalContactOption = ref({
  roles: 'employee',
  status: 'active'
});
const installmentInterval = ref([]);
const interestMethod = ref([]);
let loanRegisterData = {}
let formData = ref({
  company_id: companyId,
  status: 'active',
  contact_profile_id:'',
  loan_amount:'',
  number_of_installment:'',
  installment_interval:'',
  interest_percentage:'',
  interest_method:'',
  total_interest_amount:'',
  installment_principal_amount:'',
  installment_interest_amount:'',
  installment_amount:'',
  installment_start_date:'',
  installment_end_date:'',
})

function navigateToListPage() {
  delete route.query.loanRegisterId;
  router.push({name: `loan-registers`, params: route.params, query: route.query});
}

watch(
    () => [formData.value.loan_amount, formData.value.number_of_installment, formData.value.interest_percentage, formData.value.interest_method],
    () => {
      calculateLoan();
    }, {deep: true}
);

function calculateLoan() {
  const loanAmount = parseFloat(formData.value.loan_amount) || 0;
  const numberOfInstallment = parseInt(formData.value.number_of_installment) || 0;
  const interestPercentage = parseFloat(formData.value.interest_percentage) || 0;
  const method = formData.value.interest_method;

  if (!loanAmount || !numberOfInstallment || !method) {
    formData.total_interest_amount = 0;
    formData.installment_principal_amount = 0;
    formData.installment_interest_amount = 0;
    formData.installment_amount = 0;
    return;
  }

  let totalInterest = 0;
  let principalPerInstallment = 0;
  let interestPerInstallment = 0;
  let installmentAmount = 0;

  if (method === 'flat_rate') {
    const tenureInYears = numberOfInstallment / 12;
    const flatRateInterest = (loanAmount * interestPercentage * tenureInYears) / 100;
    const totalAmount = loanAmount + flatRateInterest;
    const emi = totalAmount / numberOfInstallment;

    principalPerInstallment = loanAmount / numberOfInstallment;
    interestPerInstallment = flatRateInterest / numberOfInstallment;
    totalInterest = flatRateInterest;

    installmentAmount = emi;
  }

  if (method === 'emi') {
    const rMonthly = (interestPercentage / 100) / 12;
    const emi = loanAmount * (rMonthly * Math.pow(1 + rMonthly, numberOfInstallment)) / (Math.pow(1 + rMonthly, numberOfInstallment) - 1);

    totalInterest = (emi * numberOfInstallment) - loanAmount;
    principalPerInstallment = loanAmount / numberOfInstallment;
    interestPerInstallment = totalInterest/ numberOfInstallment;
    installmentAmount = emi;
  }

  if (method === 'zero_interest') {
    principalPerInstallment = loanAmount / numberOfInstallment;
    installmentAmount = principalPerInstallment;
  }

  formData.value.total_interest_amount = totalInterest.toFixed(2);
  formData.value.installment_principal_amount = principalPerInstallment.toFixed(2);
  formData.value.installment_interest_amount = interestPerInstallment.toFixed(2);
  formData.value.installment_amount = installmentAmount.toFixed(2);
}

const {
  createLoanRegister,
  fetchSingleLoanRegister,
  updateLoanRegister,
  fetchTypes,
} = handleHrPayroll()
const { fetchContactProfiles } = handleContact();

function saveAP(redirect = true) {
  if (isCreate.value) {
    handleSubmit(redirect);
  }

  if (!isCreate.value) {
    handleUpdate(redirect);
  }
}

function handleSubmit(redirect) {
  loanRegisterData.company_id  = formData.value.company_id;
  loanRegisterData.status = "active";
  loanRegisterData.contact_profile_id = contactProfile.value ? contactProfile.value.id : null;
  loanRegisterData.loan_amount = formData.value.loan_amount;
  loanRegisterData.number_of_installment = formData.value.number_of_installment;
  loanRegisterData.installment_interval = formData.value.installment_interval;
  loanRegisterData.interest_percentage = formData.value.interest_percentage;
  loanRegisterData.interest_method = formData.value.interest_method;
  loanRegisterData.total_interest_amount = formData.value.total_interest_amount;
  loanRegisterData.installment_principal_amount = formData.value.installment_principal_amount;
  loanRegisterData.installment_interest_amount = formData.value.installment_interest_amount;
  loanRegisterData.installment_amount = formData.value.installment_amount;
  loanRegisterData.installment_start_date = formData.value.installment_start_date;
  loanRegisterData.installment_end_date = formData.value.installment_end_date;
  createLoanRegisterData(redirect);
}

function handleUpdate(redirect) {
  loanRegisterData.id = formData.value.id;
  loanRegisterData.contact_profile_id = contactProfile.value ? contactProfile.value.id : null;
  loanRegisterData.loan_amount = formData.value.loan_amount;
  loanRegisterData.number_of_installment = formData.value.number_of_installment;
  loanRegisterData.installment_interval = formData.value.installment_interval;
  loanRegisterData.interest_percentage = formData.value.interest_percentage;
  loanRegisterData.interest_method = formData.value.interest_method;
  loanRegisterData.total_interest_amount = formData.value.total_interest_amount;
  loanRegisterData.installment_principal_amount = formData.value.installment_principal_amount;
  loanRegisterData.installment_interest_amount = formData.value.installment_interest_amount;
  loanRegisterData.installment_amount = formData.value.installment_amount;
  loanRegisterData.installment_start_date = formData.value.installment_start_date;
  loanRegisterData.installment_end_date = formData.value.installment_end_date;
  loanRegisterData.status = formData.value.status;
  updateLoanRegisterData(redirect);
}

function createLoanRegisterData(redirect = true) {
  createLoanRegister(loanRegisterData, getQuery())
      .then(res => {
        console.log(res)
        if (!res.status) {
          showError(res.message)
          return
        }
         showSuccess(res.message)
         if (redirect) navigateToListPage()
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
        loader.value = false
      })
}

function updateLoanRegisterData(redirect = true) {
  updateLoanRegister(loanRegisterData, loanRegisterData.id, getQuery())
      .then(res => {
        if (!res.status) {
          showError(res.message)
          return
        }
         showSuccess(res.message);
         if (redirect) navigateToListPage()
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
        loader.value = false
      })
}

function getQuery() {
  return `?company_id=${route.params.companyId}`;
}

function setFormData() {
  headerTitle.value = "Update Loan Register";
  formData.value.id =  loanRegisterEditData.value.id;
  formData.value.loan_amount = loanRegisterEditData.value.loan_amount;
  formData.value.number_of_installment = loanRegisterEditData.value.number_of_installment;
  formData.value.installment_interval = loanRegisterEditData.value.installment_interval;
  formData.value.interest_percentage = loanRegisterEditData.value.interest_percentage;
  formData.value.interest_method = loanRegisterEditData.value.interest_method;
  formData.value.total_interest_amount = loanRegisterEditData.value.total_interest_amount;
  formData.value.installment_principal_amount = loanRegisterEditData.value.installment_principal_amount;
  formData.value.installment_interest_amount = loanRegisterEditData.value.installment_interest_amount;
  formData.value.installment_amount = loanRegisterEditData.value.installment_amount;
  formData.value.installment_start_date = loanRegisterEditData.value.installment_start_date;
  formData.value.installment_end_date = loanRegisterEditData.value.installment_end_date;
  formData.value.status = loanRegisterEditData.value.status;
  contactProfile.value = {
    id:loanRegisterEditData.value.contact_profile_id,
    name:loanRegisterEditData.value.employee_name
  };
}

const getTypes = async () => {
  let query = getQuery();
  await fetchTypes(query).then(res => {
    if (!res.status){
      installmentInterval.value = [];
      interestMethod.value = [];
      return
    }

    const data = res.data || {};
    installmentInterval.value = data.loanInstallmentInterval || [];
    interestMethod.value = data.loanInterestMethod || [];

  }).catch(err => {
    console.log(err)
  })
}

function onPageReload() {
  loader.value=true

  Promise.all([
    getTypes()
  ]).finally(() => {
    loader.value = false
  })

  if(route.query.loanRegisterId && route.query.loanRegisterId !== '' && route.query.loanRegisterId !== undefined){
    isCreate.value = false;
    const fetchData = fetchSingleLoanRegister(route.query.loanRegisterId, getQuery());
    fetchData.then(res2 => {
      loanRegisterEditData.value = res2.data;
      setFormData();
    });
  }
}

onMounted(() => {
  onPageReload();
})
</script>